import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationContainer, NotificationManager } from "react-notifications";
import 'react-notifications/lib/notifications.css';
import logo from "assets/images/vibo_vibo-magenta-transparent.png";
import { Form, FormGroup, Input } from "reactstrap";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress";
import * as actions from "actions";
import { isWebview } from '../../util/generalFunction';
import Img from '../../assets/images/success2.png';

class UserActivation extends Component {
    state = {
        showError: false
    }
    componentDidMount() {
        let search = this.props.location.search.split("=");
        console.log("MEGHA", search)
        if (search[0].includes("code")) {
            // this.props.showLoader();
            this.props.userActivation(search[1])
        }
        this.props.changeVerify();
        this.props.showLoader();
        const user = JSON.parse(localStorage.getItem("user-data"));

        if (user) {
            let checked =
                // eslint-disable-next-line no-nested-ternary
                this.props.initURL.indexOf("/admin") !== -1
                    ? this.props.initURL
                    : user.role.name === "Administrator" && isWebview()
                        ? "/SuperAdminMobileScreen"
                        : user.role.name === "Administrator"
                            ? "/super-admin/businesses"
                            : user.role.name === "Customer"
                                ? "/"
                                : user.role.name === "Public"
                                    ? "/access-denied"
                                    : "/admin/appointments";

            this.props.history.push(checked);
        }
    }

    componentDidUpdate() {
        if (this.props.showMessage) {
            setTimeout(() => {
                this.props.hideMessage();
            }, 100);
        }
        const user = JSON.parse(localStorage.getItem("user-data"));

        if (user) {
            let checked =
                // eslint-disable-next-line no-nested-ternary
                this.props.initURL.indexOf("/admin") !== -1
                    ? this.props.initURL
                    : user.role.name === "Administrator" && isWebview()
                        ? "/SuperAdminMobileScreen"
                        : user.role.name === "Administrator"
                            ? "/super-admin/businesses"
                            : user.role.name === "Customer"
                                ? "/"
                                : user.role.name === "Public"
                                    ? "/access-denied"
                                    : "/admin/appointments";

            this.props.history.push(checked);
        }
    }

    render() {
        document.body.classList.remove("ios-mobile-view-height");
        // const code = this.props
        let search = this.props.location.search.split("=");
        let data;
        const { email, password, loader, showMessage, alertMessage, verify, confirmpassword } = this.props;
        if (alertMessage && !this.state.showError) {
            this.setState({ showError: true });
        }
        if (!search[0].includes("code")) {
            data = (
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <div style={{ color: '#f44336', marginTop: '20px', marginBottom: '20px' }}>Sorry, Invalid Link. Please check your mail and try again.</div>
                    <Link to="/forgot-password" title="Reset Password">
                        <IntlMessages id="vibo.appModule.forgotPassword" />
                    </Link>
                </div>
            );
        } else {
            { loader ? data = <CircularProgress /> : data = null };

            {
                this.state.showError ? data = (
                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <img src={require("../../assets/images/Apierror.png")} alt="No Data" width="40px" />
                        <div style={{ color: '#f44336', marginTop: '20px', marginBottom: '20px' }}>Sorry, Something Went Wrong. Please try again after sometome.</div>
                        <p className="text-center zoomIn animation-delay-20 animated">
                            <Link
                                to="/"
                                onClick={() => {
                                    window.location.href = `mailto:admin@vibovibo.com`;
                                }}
                            >
                                <IntlMessages id="vibo.extraPages.goHome" />
                            </Link>
                        </p>
                    </div>
                ) : this.props.isSuccess ? data = (
                    <div style={{ textAlign: 'center' }} className="mt-5 mb-5">
                        <img src={Img} alt="Success" width='40' className="mb-2" />
                        <label className="mb-3">Thank you for activating your account. You can now log in and start booking appointments at any of our Vibo Vibo salons.</label>
                        <Link to="/login">Login</Link>
                    </div>
                ) : null
            }
        }

        return (
            <div className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
                <div className="login-content">
                    <div className="login-header border-bottom">
                        {isWebview() ? localStorage.getItem("isAdmin") == "true"
                            ? (
                                <div className="app-logo">
                                    <img src={logo} alt="jambo" title="Vibo Vibo" />
                                </div>
                            )
                            : (
                                <Link className="app-logo" to="/" title="Jambo">
                                    <img src={logo} alt="jambo" title="Vibo Vibo" />
                                </Link>
                            ) :
                            <Link className="app-logo" to="/" title="Jambo">
                                <img src={logo} alt="jambo" title="Vibo Vibo" />
                            </Link>
                        }
                    </div>

                    <div className="login-form">
                        {data}
                    </div>
                </div>

                {showMessage && this.state.showError && NotificationManager.error(alertMessage)}
                <NotificationContainer />
            </div>
        );
    }
}

const mapStateToProps = ({ login, auth }) => {
    const { email, password, loader, showMessage, alertMessage, verify, user, confirmpassword, isSuccess } = login;
    const { initURL } = auth;
    return { email, password, loader, showMessage, alertMessage, verify, user, initURL, confirmpassword, isSuccess };
};

const mapDispatchToProps = dispatch => ({
    userReset: payload => dispatch(actions.resetPassword(payload)),
    userPassword: password => dispatch(actions.passwordInput(password)),
    userConfirmPassword: password => dispatch(actions.confirmPasswordInput(password)),
    showLoader: () => dispatch(actions.showLoader()),
    hideLoader: () => dispatch(actions.hideLoader()),
    hideMessage: () => dispatch(actions.hideMessages()),
    changeVerify: payload => dispatch(actions.changeVerify(payload)),
    userActivation: payload => dispatch(actions.userActivation(payload)),
});

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(UserActivation)
);



// WEBPACK FOOTER //
// ./components/UserActivation/index.js